import { Meeting } from './../../interfaces/meeting.interface';
import {  Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'meeting-details-modal',
  templateUrl: './meeting-details-modal.component.html',
  styleUrls: ['./meeting-details-modal.component.scss']
})
export class MeetingDetailsModalComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  @Input() data: Meeting = {
    uId: '',
    name: '',
    meetingDate: '',
    actions: '',
    clientIdentifier: ''
  };
  constructor( ) { }
  
  ngOnInit(): void {
    
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

 
}
